module.exports = __webpack_public_path__ + "static/img/set_coconuts.3b8483d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/shop/set_coconuts.png
// module id = pt9k
// module chunks = 1